"use strict";
/**
 * @file Created on 02/14/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var ResourceLockDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ResourceLockDTOConverter, _DataObjectConverter_);

  function ResourceLockDTOConverter() {
    _classCallCheck(this, ResourceLockDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockDTOConverter).apply(this, arguments));
  }

  return ResourceLockDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ResourceLockDTOConverter = ResourceLockDTOConverter;